// ─────────────────────────────────────────────────────────────────────────────
// 🔑 pdf.js, LOADED ONLY WHEN A DOCUMENT IS VIEWED, FROM THE APP'S OWN FILES (Jesse, 2026-10-28).
//
// pdfjs-dist 5.4.296 (published 2025-10-05), the LEGACY build (older iOS/Android WebViews), vendored unmodified from
// the npm tarball (sha512 matched the registry's dist.integrity) into public/vendor/pdfjs-5.4.296/ — .mjs renamed
// .js so every WebView serves it with a JavaScript MIME type. backend/test/documentViewerCore.test.js pins the
// hashes. It ships inside the web build, so the OTA bundle carries it: no CDN, works offline, and nothing is fetched
// until the viewer opens. The worker, the standard fonts and the wasm decoders sit beside it.
// ─────────────────────────────────────────────────────────────────────────────
export const PDFJS_VERSION = '5.4.296';
const DIR = `vendor/pdfjs-${PDFJS_VERSION}/`;

// ⚠️ RESOLVED AGAINST THE PAGE'S URL, NOT window.location.origin: on iOS the app runs at capacitor://localhost, whose
// origin is opaque ("null"), so origin + path would not be a URL at all.
function assetUrl(rel) {
  return new URL(`${process.env.PUBLIC_URL || ''}/${DIR}${rel}`, window.location.href).href;
}

let loading = null;

/** → { pdfjs, options } — options for getDocument (fonts and wasm from the same folder). */
export function loadPdfJs() {
  if (!loading) {
    loading = import(/* webpackIgnore: true */ assetUrl('pdf.min.js'))
      .then((pdfjs) => {
        pdfjs.GlobalWorkerOptions.workerSrc = assetUrl('pdf.worker.min.js');
        return { pdfjs, options: { standardFontDataUrl: assetUrl('standard_fonts/'), wasmUrl: assetUrl('wasm/') } };
      })
      .catch((e) => { loading = null; throw e; });
  }
  return loading;
}
